import React from 'react';

import { useAuth } from '../hooks/useAuth.js';
import { hasAnyWorkspaceLayer, hasWorkspaceLayer } from '../utils/layerPermissions.js';

export default function LayerGate({ layer, anyOf, fallback = null, children }) {
  const { workspace } = useAuth();
  const allowed = Array.isArray(anyOf) && anyOf.length > 0
    ? hasAnyWorkspaceLayer(workspace, anyOf)
    : hasWorkspaceLayer(workspace, layer);

  if (!allowed) return fallback;
  return children;
}
